import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Accordion, AccordionSummary, AccordionDetails, Typography, Chip, CircularProgress } from '@mui/material';
import { Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ManualUtilizare from './ManualUtilizare';
import Faq from './Faq';
import CloseIcon from '@mui/icons-material/Close';

const Footer = () => {
    const [dateCont, setDateCont] = useState({});
    const [versiuni, setVersiuni] = useState([]);
    const [loadingVersiuni, setLoadingVersiuni] = useState(false);
    const [expandedVersion, setExpandedVersion] = useState(null);
   //manual
   const [openManual, setOpenManual] = useState(false);
   const handleOpenManual = () => setOpenManual(true);
   const handleCloseManual = () => setOpenManual(false);
 
   function setDenAppVers(value) {
    function setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
  
    setCookie('DenAppVers', value, 30);
  
    localStorage.setItem('DenAppVers', value);
  
    sessionStorage.setItem('DenAppVers', value);
  }

    const fetchData = async () => {
        try {
          const response = await fetch(`${window.API_URL}infoaplicatie`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
              },
          });
          const {data} = await response.json();
          setDateCont(data);
          setDenAppVers(data.appVersion);
          //console.log('[Api] -> InfoAplicatie:', data);
        } catch (error) {
          console.error(error);
        }
      };

    const fetchVersiuni = async () => {
        setLoadingVersiuni(true);
        try {
          const response = await fetch('https://juristpro.ro/versiune/versiune.json', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
              },
          });
          const data = await response.json();
          
          // Sortăm versiunile după dată (cele mai recente primele)
          const sortedData = data.sort((a, b) => new Date(b.data) - new Date(a.data));
          setVersiuni(sortedData);
          
          // Setăm prima versiune (cea mai recentă) ca fiind deschisă
          if (sortedData.length > 0) {
            setExpandedVersion(sortedData[0].id);
          }
        } catch (error) {
          console.error('Eroare la încărcarea versiunilor:', error);
        } finally {
          setLoadingVersiuni(false);
        }
      };

    const [modalOpen, setModalOpen] = useState(false);
    const [anCurent, setAnCurent] = useState(new Date().getFullYear());
    const toggleModal = () => {
      if (!modalOpen) {
        fetchVersiuni(); // Încarcă versiunile când se deschide modalul
      }
      setModalOpen(!modalOpen);
    };

    const handleAccordionChange = (versionId) => (event, isExpanded) => {
      setExpandedVersion(isExpanded ? versionId : null);
    };

    
    useEffect(() => {
        setAnCurent(new Date().getFullYear());
        fetchData();
    }, []);
    
//manual 
useEffect(() => {
  const handleKeyDown = (event) => {
    if (event.key === 'F1') {
      event.preventDefault();
      handleOpenManual();
    }
  };
  window.addEventListener('keydown', handleKeyDown);

  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, []);

const [openFaq, setOpenFaq] = useState(false);  
const handleOpenFaq = () => setOpenFaq(true);
const handleCloseFaq = () => setOpenFaq(false);

  return (
    <div className="container">
      <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top" id="margineSus0px">
        <div className="col-md-5">
          <span className="mb-2 mb-md-0 text-muted" style={{paddingLeft:'10px'}}>© {anCurent} JuristPRO NEXT - <a href="https://www.ctce.ro" target="_blank" className="link">SC CTCE SA - Soluții Software</a></span>
        </div>
        <a href="https://www.ctce.ro"  target="_blank" className="col-md-2 d-flex align-items-center justify-content-center mb-3 mb-md-0 me-md-auto link-dark text-decoration-none">
          <img src="https://www.ctce.ro/mail/juristpro/logomicctce.png" style={{ maxWidth: '70%', width: '100px' }} alt="CTCE Logo" />
        </a>
        <ul className="nav col-md-5 justify-content-end">
          <li className="nav-item">
           <a   style={{ cursor: 'pointer'}} className="nav-link px-2 text-muted"   title="Istoric versiuni aplicație"   onClick={toggleModal} >   Versiune </a>     
          </li>
          <li className="nav-item">
            <a
              onClick={handleOpenManual}
              style={{ textDecoration: 'none', cursor: 'pointer'}}
              className="nav-link px-2 text-muted"
              title="Deschideți manualul de folosire" 
            >
              Manual
            </a>
          </li>
          <li className="nav-item">
            <a
              onClick={handleOpenFaq}
              style={{ textDecoration: 'none', cursor: 'pointer'}}
              className="nav-link px-2 text-muted"
              title="Deschideți manualul de folosire"
            >
              Întrebări și răspunsuri
            </a>
          </li>

          <li className="nav-item">
            <a href="https://www.ilegis.ro" className="nav-link px-2 text-muted" style={{ textDecoration: 'none' }} target="_blank" title="Aplicația legislativă">Legislație</a>
          </li>
        </ul>
      </footer>

    
      <ManualUtilizare open={openManual} onClose={handleCloseManual} />
      <Dialog 
        open={modalOpen}
        onClose={toggleModal}
        maxWidth={false}
        fullWidth
        PaperProps={{
              style: {
              maxWidth: '800px',  
              width: '100%', 
              },
          }}
        >
        <DialogTitle className='titluModal'>
          Istoric versiuni aplicație
          <IconButton
            aria-label="close"
            onClick={toggleModal}
            sx={{
              position: 'absolute',
              right: 8,
              top: 12, 
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className='mt-3' sx={{ maxHeight: '70vh', overflowY: 'auto' }}>
 
            {loadingVersiuni ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
                <CircularProgress />
              </div>
            ) : versiuni.length > 0 ? (
              <div> 
                {versiuni.map((versiune, index) => (
                  <Accordion 
                    key={versiune.id}
                    expanded={expandedVersion === versiune.id}
                    onChange={handleAccordionChange(versiune.id)}
                    sx={{
                      marginBottom: '6px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                      '&:before': { display: 'none' },
                      borderRadius: '6px !important',
                      overflow: 'hidden',
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ fontSize: '20px' }} />}
                      sx={{
                        backgroundColor: index === 0 ? 'rgba(var(--background-color), 0.08)' : '#f8f9fa',
                        minHeight: '44px',
                        padding: '0 12px',
                        '&.Mui-expanded': {
                          minHeight: '44px',
                        },
                        '& .MuiAccordionSummary-content': {
                          margin: '8px 0',
                          alignItems: 'center',
                          gap: '10px',
                        }
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', width: '100%' }}>
                        <Chip 
                          label={versiune.versiune} 
                          size="small" 
                          sx={{ 
                            fontWeight: 600,
                            fontSize: '0.75rem',
                            height: '22px',
                            backgroundColor: index === 0 ? 'rgba(var(--background-color), 0.9)' : '#6c757d',
                            color: 'white',
                          }} 
                        />
                        <Typography sx={{ fontWeight: 500, flex: 1, fontSize: '0.9em' }}>
                          {versiune.titlu}
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#6c757d', fontSize: '0.8em' }}>
                          {new Date(versiune.data).toLocaleDateString('ro-RO', { 
                            year: 'numeric', 
                            month: 'short', 
                            day: 'numeric' 
                          })}
                        </Typography>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails sx={{ padding: '12px 16px', backgroundColor: '#fff' }}>
                      <div 
                        dangerouslySetInnerHTML={{ __html: versiune.descriere }}
                        style={{
                          fontSize: '0.9em',
                          lineHeight: '1.5',
                          color: '#333',
                        }}
                        className="versiune-descriere"
                      />
                    </AccordionDetails>
                  </Accordion>
                ))}
              </div>
            ) : (
              <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', padding: '20px' }}>
                Nu există informații despre versiuni disponibile.
              </Typography>
            )}
        </DialogContent>
        <DialogActions>
            <Button onClick={toggleModal} color="primary">
            Închidere
            </Button>
        </DialogActions>
        </Dialog>

        <style>
          {`
            .versiune-descriere img {
              max-width: 100%;
              height: auto;
              border-radius: 6px;
              margin: 10px 0;
              box-shadow: 0 2px 6px rgba(0,0,0,0.1);
            }
            
            .versiune-descriere p {
              margin-bottom: 10px;
            }
            
            .versiune-descriere ul {
              margin-left: 18px;
              margin-bottom: 10px;
            }
            
            .versiune-descriere li {
              margin-bottom: 4px;
            }
            
            .versiune-descriere strong {
              font-weight: 600;
              color: rgba(var(--background-color), 1);
            }
          `}
        </style>

        <Dialog 
          open={openFaq} 
          onClose={handleCloseFaq}
          maxWidth={false}
          fullWidth
          PaperProps={{
              style: {
              maxWidth: '1100px',  
              width: '100%', 
              },
          }}
        >
          <DialogTitle className='titluModal'>Întrebări și răspunsuri</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleCloseFaq}
            sx={{
              position: 'absolute',
              right: 8,
              top: 12, 
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <Faq /> 
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseFaq} color="primary">Închidere</Button>
          </DialogActions>
        </Dialog>

       

    </div>
  );
};

export default Footer;
